module.exports = __webpack_public_path__ + "static/img/menu_android.b90e14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_android.png
// module id = 3iTA
// module chunks = 1